import HttpCliente from "../HttpCliente";

/**
 * POST method - Envía un formulario de contacto
 * @param {Object} formData - Datos del formulario (name, email, subject, message)
 * @param {string} recaptchaToken - Token de verificación reCAPTCHA
 * @param {Function} setFormStatus - Función para establecer el estado del formulario
 * @param {Function} setIsSubmitting - Función para establecer el estado de envío
 * @param {Function} resetForm - Función para restablecer el formulario después de un envío exitoso
 * @return {Promise} Promesa de envío
 */
export const sendContactForm = (formData, recaptchaToken, setFormStatus, setIsSubmitting, resetForm) => {
    return new Promise((resolve, reject) => {
        // Asegurarse de que todos los campos requeridos están presentes
        if (!formData.name || !formData.email || !formData.subject || !formData.message) {
            setFormStatus('error');
            reject('Todos los campos son obligatorios');
            return;
        }

        // Configurar el estado de envío
        setIsSubmitting(true);
        setFormStatus('sending');

        HttpCliente.post('/Email', {
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
            recaptchaToken: recaptchaToken
        }, {
            headers: {
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                setFormStatus('success');
                resetForm(); // Restablecer el formulario
                resolve(response.data);
            } else {
                setFormStatus('error');
                reject(response.data.message || 'Error al enviar el mensaje');
            }
        })
        .catch(error => {
            setFormStatus('error');
            const errorMessage = error.response?.data?.message || "Error de conexión";
            reject(errorMessage);
        })
        .finally(() => {
            setIsSubmitting(false);
        });
    });
};

/**
 * Valida el formulario de contacto
 * @param {Object} formData - Datos del formulario
 * @param {string} recaptchaToken - Token de verificación reCAPTCHA
 * @param {Function} setFormErrors - Función para establecer los errores del formulario
 * @return {boolean} Resultado de la validación
 */
export const validateContactForm = (formData, recaptchaToken, setFormErrors) => {
    const errors = {};
    
    if (!formData.name.trim()) {
        errors.name = 'El nombre es obligatorio';
    }
    
    if (!formData.email.trim()) {
        errors.email = 'El email es obligatorio';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        errors.email = 'Email inválido';
    }
    
    if (!formData.subject.trim()) {
        errors.subject = 'El asunto es obligatorio';
    }
    
    if (!formData.message.trim()) {
        errors.message = 'El mensaje es obligatorio';
    } else if (formData.message.length < 10) {
        errors.message = 'El mensaje debe tener al menos 10 caracteres';
    }
    
    if (!formData.acceptTerms) {
        errors.acceptTerms = 'Debes aceptar los términos y condiciones';
    }
    
    if (!recaptchaToken) {
        errors.recaptcha = 'Por favor, verifica que no eres un robot';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
};